import { ref } from "vue";

const visible = ref(false);

export function useGlobalLoading() {
  const showLoading = () => (visible.value = true);
  const hideLoading = () => (visible.value = false);

  return { visible, showLoading, hideLoading };
}
